import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { removeNotification } from '../../redux/actions';

const Notification = () => {
    const notificationState = useSelector(
        (state: any) => state.notification
    );

    //const [timeout, setTimeout] = useState(5000);
    const [timestamp, setTimestamp] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        if (notificationState && notificationState.length) {
            const max = Math.max.apply(Math, notificationState.map(function (o) { return o.timestamp; }));
            notificationState.forEach((n) => {
                if (n.timestamp > timestamp) {
                    if (n.text) {
                        switch (n.type) {
                            case 'success':
                                //setTimeout(2000);
                                toast.success(n.text, {
                                    closeButton: true
                                });
                                break;
                            case 'info':
                                //setTimeout(1000);
                                toast.info(n.text, {
                                    closeButton: true
                                });
                                break;
                            case 'error':
                                //setTimeout(5000);
                                toast.error(n.text, {
                                    closeButton: true
                                });
                                break;
                        }
                    }
                }
            });
            notificationState.forEach((n) => {
                dispatch(removeNotification(n));
            });
            setTimestamp(max);
        }

    }, [notificationState]);

    return (
        <ToastContainer
        //hideProgressBar={false}
        //closeButton={true}
        //newestOnTop={true}
        //autoClose={1000}
        //limit={10}
        />
    );
};

export default Notification;

export const useNotification = (text: any) => {

}